import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-webinar';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Webinar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getWebinarlist();
  }


  deleteWebinar = (id) => {
    confirmAlert({
      title: 'Delete Webinar',
      message: 'Are you sure to delete the webinar?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteWebinar(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.webinarList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const webinars = this.props.webinarList.filter((item) => item.Title.toLowerCase().includes(searchVal) || item.AuthorName.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Title',
      text: 'Webinar Name'
    }, {
      dataField: 'AuthorName',
      text: 'Author Name'
    }, {
      dataField: 'AboutAuthor',
      text: 'About Author'
    }, {
      dataField: 'SlugURL',
      text: 'Slug URL'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/webinar-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteWebinar(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Webinar" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-laptop-code cardTitle"> Webinar</span> */}
                    <SearchBar
                      placeholder="Search by Webinar Name, Author Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.push('/webinar-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                <BootstrapTable
                  keyField="Id"
                  data={webinars}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Webinar.defaultProps = {
  tableLoading: false,
  webinarList: null,
  getWebinarlist: null,
  deleteWebinar: null
};

Webinar.propTypes = {
  tableLoading: PropTypes.bool,
  webinarList: PropTypes.array,
  getWebinarlist: PropTypes.func,
  deleteWebinar: PropTypes.func
};

const mapStateToProps = ({ webinar }) => ({
  tableLoading: webinar.tableLoading,
  webinarList: webinar.webinarList
});

const mapDispatchToProps = (dispatch) => ({

  getWebinarlist: () => dispatch(actions.fetchWebinar()),
  deleteWebinar: (id) => dispatch(actions.deleteWebinar(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Webinar);
